webpackJsonp([29],{

/***/ 1347:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _map = __webpack_require__(57);

var _map2 = _interopRequireDefault(_map);

var _reject = __webpack_require__(1655);

var _reject2 = _interopRequireDefault(_reject);

var _section = __webpack_require__(912);

var _section2 = _interopRequireDefault(_section);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'amp-latest-news',
  props: ['node'],
  mixins: [_section2.default],
  components: {
    AmpLabel: function AmpLabel() {
      return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1316));
    }
  },
  computed: {
    latestNews: function latestNews() {
      var nodeTid = this.getLastSection((0, _get2.default)(this, 'node.sections', []));
      var nodeQueue = this.$store.getters.nodeQueue('section_top-' + nodeTid) || {};
      var list = (0, _map2.default)(nodeQueue, this.getNode);
      return (0, _reject2.default)(list, { nid: this.node.nid }).slice(0, 3);
    }
  },
  methods: {
    getNode: function getNode(nid) {
      return this.$store.state.nodes[nid];
    },
    title: function title(node) {
      return (0, _get2.default)(node, 'title', '');
    },
    thumbnail: function thumbnail(node) {
      return (0, _get2.default)(node, 'images[0].style_134w', '/image/placeholder/32/40/5A9CB5/20');
    },
    newsUrl: function newsUrl(node) {
      return (0, _get2.default)(node, 'relative_url', '');
    }
  }
};

/***/ }),

/***/ 1543:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".latestNews[data-v-d73edd46]{border-top:2px solid #999;margin-top:1.875rem;margin-left:1.25rem;margin-right:1.25rem;padding-top:1.25rem}.latestNews__heading[data-v-d73edd46]{text-transform:uppercase;color:#666;font-size:1.25rem;font-weight:700;padding-bottom:.3125rem}.latestNews__content[data-v-d73edd46]{padding-left:.5rem;padding-right:.5rem;position:relative;overflow:hidden}.latestNews .article[data-v-d73edd46]{margin-top:.75rem;overflow:hidden;position:relative}.latestNews .article a[data-v-d73edd46]{display:block}.latestNews .article[data-v-d73edd46]:not(:last-child){border-bottom:1px solid #f8008e;padding-bottom:1rem}.latestNews .article[data-v-d73edd46]:not(:last-child):after{background-color:#f8008e;bottom:.1875rem;content:\"\";position:absolute;width:100%;height:.0625rem;left:0}.latestNews .article__title[data-v-d73edd46]{color:#222;font-size:1.5rem;height:5.4375rem;width:66%;float:left;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;margin-top:.5rem}.latestNews .article__image[data-v-d73edd46]{color:#222;font-size:1.5rem;width:33%;float:right;margin-top:.5rem}", "", {"version":3,"sources":["/app/components/article/amp/AmpLatestNews.vue"],"names":[],"mappings":"AAgCA,6BACE,0BAA8B,AAC9B,oBAAqB,AACrB,oBAAqB,AACrB,qBAAsB,AACtB,mBAAqB,CACtB,AACD,sCACI,yBAA0B,AAC1B,WAAe,AACf,kBAAmB,AACnB,gBAAkB,AAClB,uBAA0B,CAC7B,AACD,sCACI,mBAAqB,AACrB,oBAAsB,AACtB,kBAAmB,AACnB,eAAiB,CACpB,AACD,sCACI,kBAAoB,AACpB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,wCACM,aAAe,CACpB,AACD,uDACM,gCAAiC,AACjC,mBAAqB,CAC1B,AACD,6DACQ,yBAA0B,AAC1B,gBAAkB,AAClB,WAAY,AACZ,kBAAmB,AACnB,WAAY,AACZ,gBAAkB,AAClB,MAAQ,CACf,AACD,6CACM,WAAe,AACf,iBAAkB,AAClB,iBAAkB,AAClB,UAAW,AACX,WAAY,AACZ,oBAAqB,AACrB,qBAAsB,AACtB,4BAA6B,AAC7B,gBAAiB,AACjB,0BAA2B,AACxB,uBAAwB,AAC3B,gBAAmB,CACxB,AACD,6CACM,WAAe,AACf,iBAAkB,AAClB,UAAW,AACX,YAAa,AACb,gBAAmB,CACxB","file":"AmpLatestNews.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.latestNews[data-v-d73edd46] {\n  border-top: 2px solid #999999;\n  margin-top: 1.875rem;\n  margin-left: 1.25rem;\n  margin-right: 1.25rem;\n  padding-top: 1.25rem;\n}\n.latestNews__heading[data-v-d73edd46] {\n    text-transform: uppercase;\n    color: #666666;\n    font-size: 1.25rem;\n    font-weight: bold;\n    padding-bottom: 0.3125rem;\n}\n.latestNews__content[data-v-d73edd46] {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n    position: relative;\n    overflow: hidden;\n}\n.latestNews .article[data-v-d73edd46] {\n    margin-top: 0.75rem;\n    overflow: hidden;\n    position: relative;\n}\n.latestNews .article a[data-v-d73edd46] {\n      display: block;\n}\n.latestNews .article[data-v-d73edd46]:not(:last-child) {\n      border-bottom: 1px solid #F8008E;\n      padding-bottom: 1rem;\n}\n.latestNews .article[data-v-d73edd46]:not(:last-child):after {\n        background-color: #F8008E;\n        bottom: 0.1875rem;\n        content: \"\";\n        position: absolute;\n        width: 100%;\n        height: 0.0625rem;\n        left: 0;\n}\n.latestNews .article__title[data-v-d73edd46] {\n      color: #222222;\n      font-size: 1.5rem;\n      height: 5.4375rem;\n      width: 66%;\n      float: left;\n      display: -webkit-box;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      -o-text-overflow: ellipsis;\n         text-overflow: ellipsis;\n      margin-top: 0.5rem;\n}\n.latestNews .article__image[data-v-d73edd46] {\n      color: #222222;\n      font-size: 1.5rem;\n      width: 33%;\n      float: right;\n      margin-top: 0.5rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1632:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1543);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("5b077003", content, true, {});

/***/ }),

/***/ 1654:
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

module.exports = negate;


/***/ }),

/***/ 1655:
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(164),
    baseFilter = __webpack_require__(379),
    baseIteratee = __webpack_require__(74),
    isArray = __webpack_require__(10),
    negate = __webpack_require__(1654);

/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */
function reject(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, negate(baseIteratee(predicate, 3)));
}

module.exports = reject;


/***/ }),

/***/ 1690:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1632)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1347),
  /* template */
  __webpack_require__(1788),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d73edd46",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1788:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "latestNews"
  }, [_c('div', {
    staticClass: "latestNews__heading"
  }, [_vm._v("\n    latest news\n  ")]), _c('div', {
    staticClass: "latestNews__content"
  }, _vm._l((_vm.latestNews), function(news, index) {
    return _c('div', {
      key: index,
      staticClass: "article"
    }, [_c('div', {
      staticClass: "article__sectionLable"
    }, [_c('amp-label', {
      attrs: {
        "node": news,
        "mode": "latestNews"
      }
    })], 1), (_vm.newsUrl) ? _c('a', {
      attrs: {
        "href": _vm.newsUrl(news)
      }
    }, [_c('div', {
      staticClass: "article__title"
    }, [_vm._v(_vm._s(_vm.title(news)))]), _c('div', {
      staticClass: "article__image"
    }, [_c('amp-img', {
      attrs: {
        "src": _vm.thumbnail(news),
        "width": "400",
        "layout": "responsive",
        "height": "300"
      }
    })], 1)]) : _vm._e()])
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 912:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _head = __webpack_require__(145);

var _head2 = _interopRequireDefault(_head);

var _isArray = __webpack_require__(10);

var _isArray2 = _interopRequireDefault(_isArray);

var _last = __webpack_require__(146);

var _last2 = _interopRequireDefault(_last);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: {
    sectionColor: function sectionColor() {
      if ((0, _get2.default)(this, 'sections')) {
        var section = (0, _last2.default)((0, _head2.default)(this.sections));
        return (0, _get2.default)(section, 'color_info.hex', '');
      }
      return '';
    },
    firstSectionLineage: function firstSectionLineage() {
      var firstLineage = [];
      if ((0, _get2.default)(this, 'sections') && (0, _isArray2.default)(this.sections)) {
        firstLineage = (0, _head2.default)(this.sections);
      }
      return firstLineage;
    },
    firstSection: function firstSection() {
      var section = {};
      if ((0, _isArray2.default)(this.firstSectionLineage)) {
        section = (0, _head2.default)(this.firstSectionLineage);
      }
      return section;
    },
    lastSection: function lastSection() {
      var section = {};
      if ((0, _isArray2.default)(this.firstSectionLineage)) {
        section = (0, _last2.default)(this.firstSectionLineage);
      }
      return section;
    }
  },
  methods: {
    getLastSection: function getLastSection(sections) {
      if (sections && (0, _isArray2.default)(sections)) {
        return (0, _last2.default)((0, _head2.default)(sections));
      }
      return false;
    }
  }
};

/***/ })

});


// WEBPACK FOOTER //
// 29.c6d55b3ba38acd90a934.js